import { useDataSourceColumns } from "@/hooks";
import type { FindReplaceTransformer } from "@/types/workspace";
import { Flex, Input, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerFindReplace({
  data,
  warning,
  error,
  onUpdate,
  index,
}: {
  data: FindReplaceTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: FindReplaceTransformer) => void;
  index: number;
}) {
  const [column, setColumn] = useState(data.item_list[0]?.column || "");
  const [find, setFind] = useState(data.item_list[0]?.find || "");
  const [replace, setReplace] = useState(data.item_list[0]?.replace || "");
  const availableColumns = useDataSourceColumns(index);

  useEffect(() => {
    setColumn(data.item_list[0]?.column || "");
    setFind(data.item_list[0]?.find || "");
    setReplace(data.item_list[0]?.replace || "");
  }, [data.item_list]);

  const handleColumnChange = (value: string | null) => {
    if (value !== null) {
      setColumn(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [{ column: value, find, replace }],
        });
      }
    }
  };

  const handleFindChange = (val: string) => {
    setFind(val);
    if (onUpdate) {
      onUpdate({
        ...data,
        item_list: [{ column, find: val, replace }],
      });
    }
  };

  const handleReplaceChange = (val: string) => {
    setReplace(val);
    if (onUpdate) {
      onUpdate({
        ...data,
        item_list: [{ column, find, replace: val }],
      });
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Flex direction="row" gap={8}>
        <Select
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Column"
          data={availableColumns.length > 0 ? availableColumns : []}
          value={column}
          onChange={handleColumnChange}
        />
        <Input
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Find"
          value={find}
          onChange={(e) => handleFindChange(e.target.value)}
        />
        <Input
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Replace"
          value={replace}
          onChange={(e) => handleReplaceChange(e.target.value)}
        />
      </Flex>
    </TransformerBase>
  );
}
